<template>
  <div class="rfp-ratings-carousel-slide">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'rfp-ratings-slide',
};
</script>
